<template>
  <div class="avecor-table pa-4"  >
    <v-row no-gutters>
      <v-col cols="12">
        <v-toolbar-title >
          {{this.details.name}}
          <span class="pl-3 pr-1" v-if="allAccess"><v-icon size="12"  @click="editCompetition()" color="#666">fas fa-pencil-alt</v-icon></span>
          <span v-if="allAccess"><v-icon size="12" @click="deleteCompetition()" color="#666">far fa-trash-alt</v-icon></span>
        </v-toolbar-title>
      </v-col>
      <v-col cols="12">
        <div style="font-size:11px;" v-if="details.description" >
          <b>Kuvausteksti:</b> {{details.description}}
        </div>
        <div style="font-size:11px;" >
          <b>Mittari:</b> {{metrics[details.metric] ? metrics[details.metric].fi : ''}}
        </div>
        <!-- <div style="font-size:11px;" >
          <b>Myyjän tavoite:</b> {{details.userGoal}}
        </div>
        <div style="font-size:11px;" >
          <b>Tiimin tavoite:</b> {{details.teamGoal}}
        </div> -->
        <div style="font-size:11px;">
          <b>Alkamispäivä:</b> {{customFormatter(details.startDate)}}
        </div>
        <div style="font-size:11px;">
          <b>Lopetuspäivä:</b> {{customFormatter(details.endDate)}}
        </div>
        <div style="font-size:11px;height:50px;overflow-y:scroll" v-if="Array.isArray(details.products) && details.products.length > 0">
          <div v-for="(p,i) in productNames" :key="details.id+'_product_'+i" >
            <b>Tuote:</b> {{p}}
          </div>
          
        </div>
        <div style="font-size:11px;height:50px;overflow-y:scroll" v-else>
          <b>Tuotteet:</b> kaikki tuotteet
        </div>
        
      </v-col>
      <!-- <v-col cols="4" class="text-right ">
        <v-autocomplete
          v-if="allAccess && split && split === 'companies'"
          style=""
          label="Myyjä"
          :value="salespersonFilter"
          @change="v => salespersonFilter = v"
          :items="getSalespersons()"
          outlined
          dense
          item-text="firstName"
          item-value="id"
          class="avecor-select hide-field-details text-right mr-4"
        />
        

      </v-col> -->

    </v-row>
    <v-row no-gutters v-if="getAllData.goal && getAllData.result" class="pb-5">
      <v-col cols="12">
         <div class="v-data-table theme--light">
            <div class="v-data-table__wrapper">
               <table > 
                  <tbody>
                     <tr>
                        <td style="width:145px;font-size:20px !important;">Tiimi</td>
                        <td style="width:90px;font-size:14px !important;">
                           <div>Viim. vuosi</div>
                           <div>{{getAllData.previousYearResult}}{{details.metric === 'sales' || details.metric === 'margins' ? ' €' : '' }}</div>
                        </td>
                        <td style="width:90px;font-size:14px !important;">
                           <div>Tavoite</div>
                           <div>{{getAllData.goal}}{{details.metric === 'sales' || details.metric === 'margins' ? ' €' : '' }}</div>
                        </td>
                        <td style="width:90px;font-size:14px !important;">
                           <div>Tulos</div>
                           <div>{{getAllData.result}}{{details.metric === 'sales' || details.metric === 'margins' ? ' €' : '' }}</div>
                        </td>
                        
                        <td>
                           <v-progress-linear
                              background-color="#CCC"
                              color="#FF9E00"
                              :active="true"
                              background-opacity="0.3"
                              :bottom="false"
                              :buffer-value="100"
                              :height="16"
                              :rounded="false"
                              :stream="false"
                              :striped="false"
                              :top="false"
                              :value="getAllData.result ? ((getAllData.result)/getAllData.goal)*100 : 0"
                           ></v-progress-linear>

                        </td>
                        <td style="font-size:14px !important;width:30px;">
                           <span style="font-size: 20px;">{{getAllData.result ? Math.round(((getAllData.result)/getAllData.goal)*1000)/10 +'%' : 0}}</span>      
                        </td>
                     </tr>
                  </tbody>

               </table>
            </div>
         </div>

         <!-- <div style="width:24%;display:inline-block">
            Tiimin tavoite 
            <span class="pl-7">{{getAllData.result}}
            {{details.metric === 'sales' || details.metric === 'margins' ? ' €' : '' }}</span>
         </div>
         <div style="display:inline-block;width:70%;">
            <v-progress-linear
               background-color="#CCC"
               color="#FF9E00"
               :active="true"
               background-opacity="0.3"
               :bottom="false"
               :buffer-value="100"
               :height="16"
               :rounded="false"
               :stream="false"
               :striped="false"
               :top="false"
               :value="getAllData.result ? ((getAllData.result)/details.teamGoal)*100 : 0"
            ></v-progress-linear>
         </div>
         <div style="display:inline-block;text-align:right;width:10%" >
            <span style="font-size: 20px;">{{getAllData.result ? Math.round(((getAllData.result)/details.teamGoal)*1000)/10 +'%' : 0}}</span>
         </div> -->
         
         
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="dataFiltered"
      hide-default-footer
      
      :sort-by="['result']"
      :sort-desc="[true]"
      ref="table"
      disable-pagination
      :expand="true"
      dense
      
    >
      <template v-slot:item="props" >
        <!--<td class="text-xs-left">{{ props.item.number }}</td>-->
        <tr v-if="props.item.salespersonId !== 'all'" style="height:35px;" >
          <td class="" style="max-width:45px;margin-left:10px;width:45px;">
            {{props.index + 1}}
          </td>
          <td class="text-xs-left" style="min-width:100px;max-width:150px;width:100px">
            {{props.item.firstName }}
            <!-- {{split === 'companies' && allAccess ? props.item[firstColumnField] + ' (' +props.item.salespersonName +')' : props.item[firstColumnField] }} -->
          </td>
          <td style="width:90px;" v-if="allAccess">
            {{props.item.previousYearResult}}
            {{details.metric === 'sales' || details.metric === 'margins' ? ' €' : '' }}
          </td>
          <td style="width:90px;">
            {{props.item.goal ? props.item.goal : 0}}
            {{details.metric === 'sales' || details.metric === 'margins' ? ' €' : '' }}
          </td>
          <td style="width:90px;">
            {{props.item.result}}
            {{details.metric === 'sales' || details.metric === 'margins' ? ' €' : '' }}
          </td>
          
          
          <td>
            <v-progress-linear
               v-if="props.item.salespersonId === 'all'"
               background-color="#CCC"
               color="#FF9E00"
               :active="true"
               background-opacity="0.3"
               :bottom="false"
               :buffer-value="100"
               :height="4"
               :rounded="false"
               :stream="false"
               :striped="false"
               :top="false"
               :value="props.item.result ? ((props.item.result)/props.item.goal)*100 : 0"
            ></v-progress-linear>
            <v-progress-linear
               v-if="props.item.salespersonId !== 'all'"
               background-color="#CCC"
               color="#FF9E00"
               :active="true"
               background-opacity="0.3"
               :bottom="false"
               :buffer-value="100"
               :height="4"
               :rounded="false"
               :stream="false"
               :striped="false"
               :top="false"
               :value="props.item.result ? ((props.item.result)/props.item.goal)*100 : 0"
            ></v-progress-linear>
          </td>
          <td style="font-size:14px !important;width:30px;">
            <span v-if="props.item.salespersonId === 'all'">{{(Math.round(props.item.result ? ((props.item.result)/props.item.goal)*100 : 0))}}%</span>
            <span v-else >{{(Math.round(props.item.result ? ((props.item.result)/props.item.goal)*100 : 0))}}%</span>
          </td>

        </tr>
      </template>
      <template slot="no-data">
      </template>
    </v-data-table>
  </div>
</template>


<script>
import { mapFields } from 'vuex-map-fields'
import dateFormat from 'dateformat'
import firebase from 'firebase'

var db = null

export default {
    props: ['label','data','field', 'split','details','productNames'],
    data: () => ({
      salespersonFilter:null,
      isEditing: false,
      pagination: {'sortBy': 'result', 'descending': true, 'rowsPerPage': 15, sortable:true},
      
    }),
    watch: {
      allAccess:{
        handler(val){
          console.log(val)
          if(!this.allAccess) {
            this.salespersonFilter = this.user.uid
          }
          else this.salespersonFilter = 'all'
        }
      }
    },
    mounted() {
      db = firebase.firestore();
      if(!this.allAccess) {
        this.salespersonFilter = this.user.uid
      }
      else this.salespersonFilter = 'all'
    },
    computed: {
      getAllData(){
         var all = {}
         this.data.forEach(item => {
            item.salespersonId === 'all' ? all = item : ''
         })
         return all
      },
      headers(){
        var items = []
        items.push({ text: 'Rank', value: 'index', align: 'center', sortable: false })
        items.push({ text: 'Myyjä', value: 'firstName', align: 'left', sortable: false })
        this.allAccess ? items.push({ text: 'Viim. vuosi', value: 'result', align: 'left', sortable: false }) : ''
        items.push({ text: 'Tavoite', value: 'goal', align: 'left', sortable: false })
        items.push({ text: 'Tulos', value: 'result', align: 'left', sortable: false })
        
        items.push({ text: 'Status', value: 'result', align: 'left', sortable: false })
        items.push({ text: '', value: 'result', align: 'left', sortable: false })
        return items
      },
      dataFiltered(){
         var arr = []
         this.data.forEach(item => {
            item.salespersonId === 'all' ? '' : arr.push(item)
         })
         return arr
      },
      teamData(){
         var all = null
         this.data.forEach(item => {
            item.salespersonId === 'all' ? all = item : ''
         })
         return all
      },
      firstColumnField(){
        return this.field ? this.field : 'firstName'
      },
      allAccess(){
        return this.staff[this.user.uid] !== undefined && (this.staff[this.user.uid].isAdmin || this.staff[this.user.uid].role == 'office' || this.staff[this.user.uid].role == 'warehouse')
      },
      ...mapFields({
        user:"user",
        staff:"staff.staff",
        metrics:"settings.metrics",
        newCompetitionModalVisible:"modals.report.competition.new.visible",
        newCompetitionModalData:"modals.report.competition.new.data",
      })
    },
    created () {
    },
    methods: {
      editCompetition(){
         this.newCompetitionModalData = this.details
         this.newCompetitionModalVisible = true
      },
      deleteCompetition(){
        var t = this
        var id = this.details.id
        console.log(id)
        
        if(id !== ""){
          if (confirm('Haluatko varmasti poistaa kilpailun?')) {
            db.collection('competitions').doc(id).delete().then(function() {
              t.$store.dispatch('showSnack', { snack:true, snackTimeout:3000, snackText:"Kilpailu poistettu", snackButtonText: "OK", errorType:"", snackColor:'success',right:true,top:true})
            }).catch(function(error) {
                console.error("Error removing document: ", error);
                alert("Kilpailua ei voitu poistaa:" + error)
            });
          }
        }
      },
      customFormatter(date,full) {
        if(!date) return ''
        if (date.seconds) {
          var myDate = new Date(date.seconds*1000);
          if(full) return dateFormat(myDate, "yyyy-mm-dd HH:MM")
          return dateFormat(myDate, "yyyy-mm-dd")
        }
        else if (date !== undefined && date.seconds === undefined){
          if(full) return dateFormat(date, "yyyy-mm-dd HH:MM")
          return dateFormat(date, "yyyy-mm-dd")
        }
        return ''
      },
      getSalespersons(){
        var staff = this.staff
        var salespersons = []
        salespersons.push({id:'all',firstName:'--Kaikki--' })
        for (const key in this.staff){
          if(this.staff[key].role === 'sales' && !this.staff[key].isExit) {
            salespersons.push({id:key,firstName:this.staff[key].firstName, })
          }
        }
        return salespersons
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/blocks/ReportCompetition.vue